<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kg5XsZ/tc-custom/9780374712037.jpg?1724847858022" alt="This image is the cover for the book Hotel Florida"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hotel Florida
      </h1>
      <p class="bookDescription body article font2">
        <b>“[An] utterly compelling account . . . of the intrepid—and sometimes crazy—journalists who risked everything to report on the Spanish Civil War.” —Amanda Foreman, <i>New York Times</i>–bestselling author</b><br/><br/>Madrid, 1936. In a city blasted by a civil war that many fear will cross borders and engulf Europe—a conflict one writer will call “the decisive thing of the century” —six people meet and find their lives changed forever. Ernest Hemingway, his career stalled, his marriage sour, hopes that this war will give him fresh material and new romance; Martha Gellhorn, an ambitious novice journalist hungry for love and experience, thinks she will find both with Hemingway in Spain. Robert Capa and Gerda Taro, idealistic young photographers based in Paris, want to capture history in the making and are inventing modern photojournalism in the process. And Arturo Barea, chief of the Spanish government’s foreign press office, and Ilsa Kulcsar, his Austrian deputy, are struggling to balance truth-telling with loyalty to their sometimes compromised cause—a struggle that places both of them in peril.<br/><br/>Beginning with the cloak-and-dagger plot that precipitated the first gunshots of the war and moving forward month by month to the end of the conflict. <i>Hotel Florida</i> traces the tangled and disparate wartime destinies of these three couples against the backdrop of a critical moment in history: a moment that called forth both the best and the worst of those caught up in it. In this noir landscape of spies, soldiers, revolutionaries, and artists, the shadow line between truth and falsehood sometimes became faint indeed—your friend could be your enemy and honesty could get you (or someone else) killed.<br/><br/><b>Includes 16 pages of black-and-white photographs</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Vaill
      </h2>
      
      <p class="authorDescription body article"><B>Amanda Vaill</B> is the author of  the bestselling <I>Everybody Was So Young: Gerald and Sara Murphy</I>—<I>A Lost Generation Love Story</I>, which was a finalist for the National Book Critics Circle Award in biography, and <I>Somewhere: The Life of Jerome Robbins</I>, for which she was awarded a Guggenheim fellowship. In addition to her screenplay for the Emmy– and Peabody Award–winning public television documentary <I>Jerome Robbins: Something to Dance About</I>, she has also written features and criticism for a range of journals from <I>Allure</I> to <I>The Washington Post Book World</I>. She lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2eb90d05